import { authConstants, organizationConstants, topicConstants } from '../actions'

const initialState = {
    loadingOrganizationInfo: false,
    myOrganizations: [],
    loadingOrganizations: false,
    selectedOrganization: '',
    organizationUsers: [],
    availableFileReferences: [],
    availableCourseGroups: [],
    organizationCourseGroups: [],
    isFetchingOrganizationUsers: false,
    organizationFactBoxStats: null,
    organizationIdToFactBoxStats: {},
    organizationCourseGroupUsage: null,
    courseStatsOverview: null,
    courseStatsOverviewLoading: false,
    courseStatsTopicTrend: null,
    courseStatsTopicTrendLoading: false,
    courseStatsFilterPresets: [],
    courseStatsCatalogue: null,
    courseStatsFilterResult: null,
    courseStatsFilterLoading: false,
    courseStatsExporting: false,
    isExportingOrgExcelReport: false,
    fetchingCourseGroups: false,
    isUploadingUserImport: false,
    userImportResult: null,
    userImportError: null,
    isDownloadingImportTemplate: false,
    studentInviteResult: null,
    isFetchingEmailPreview: false,
    emailPreviewResult: null,
    isSendingOrganizationEmail: false,
    emailSendResult: null,
}

export function organization(state = initialState, action) {
    switch (action.type) {
        case organizationConstants.GET_ORGANIZATION_INFO.REQUEST:
            return {
                ...state,
                loadingOrganizationInfo: true,
            }
        case organizationConstants.GET_ORGANIZATION_INFO.SUCCESS:
            return {
                ...state,
                loadingOrganizationInfo: false,
                organizationInfo: action.data,
            }
        case organizationConstants.GET_ORGANIZATION_INFO.FAILURE:
            return {
                ...state,
                loadingOrganizationInfo: false,
                error: action.message,
            }

        case organizationConstants.SET_ORGANIZATION_INFO.REQUEST:
            const updatedOrganizations = state.myOrganizations.map((org) => {
                if (org.id === action.payload.id) {
                    return { ...org, ...action.payload }
                }
                return org
            })
            return {
                ...state,
                myOrganizations: updatedOrganizations,
            }
        case organizationConstants.SET_ORGANIZATION_INFO.SUCCESS:
            return {
                ...state,
            }
        case organizationConstants.SET_ORGANIZATION_INFO.FAILURE:
            return {
                ...state,
                error: action.message,
            }

        case organizationConstants.GET_MY_ORGANIZATIONS.REQUEST:
            return {
                ...state,
                loadingOrganizations: true,
            }
        case organizationConstants.GET_MY_ORGANIZATIONS.SUCCESS:
            return {
                ...state,
                myOrganizations: action.data,
                loadingOrganizations: false,
                selectedOrganization: state.selectedOrganization ? state.selectedOrganization : action.data[0].id,
            }
        case organizationConstants.GET_MY_ORGANIZATIONS.FAILURE:
            return {
                ...state,
                loadingOrganizations: false,
                error: action.message,
            }

        case organizationConstants.SET_CURRENT_ORGANIZATION.REQUEST:
            return {
                organizationUsers: [],
                usergroups: [],
                userGroupUsers: [],
                availableFileReferences: [],
                inviteRolesAvailable: [],
                organizationFileAssets: [],
                availableCourseGroups: [],
                organizationCourseGroups: [],
                ...state,
            }
        case organizationConstants.SET_CURRENT_ORGANIZATION.SUCCESS:
            return {
                ...state,
                selectedOrganization: action.data,
            }
        case organizationConstants.SET_CURRENT_ORGANIZATION.FAILURE:
            return {
                ...state,
                error: action.message,
            }

        case organizationConstants.GET_SCHOOL.REQUEST:
            return {
                ...state,
                loadingSchool: true,
            }
        case organizationConstants.GET_SCHOOL.SUCCESS:
            return {
                ...state,
                loadingSchool: false,
                school: action.data.school,
            }
        case organizationConstants.GET_SCHOOL.FAILURE:
            return {
                ...state,
                loadingSchool: false,
                error: action.message,
            }

        case organizationConstants.CREATE_SCHOOL.REQUEST:
            return {
                ...state,
                creatingSchool: true,
            }
        case organizationConstants.CREATE_SCHOOL.SUCCESS:
            return {
                ...state,
                creatingSchool: false,
                //TODO: Add this to the above schools
                createdSchool: action.data.school,
            }
        case organizationConstants.CREATE_SCHOOL.FAILURE:
            return {
                ...state,
                creatingSchool: false,
                error: action.message,
            }

        case organizationConstants.INVITE_STUDENTS_SCHOOL.REQUEST:
            return {
                ...state,
                addingStudents: true,
            }
        case organizationConstants.INVITE_STUDENTS_SCHOOL.SUCCESS:
            return {
                ...state,
                studentAddedSuccess: true,
                addingStudents: false,
            }
        case organizationConstants.INVITE_STUDENTS_SCHOOL.FAILURE:
            return {
                ...state,
                error: action.message,
            }


        case organizationConstants.INVITE_STUDENTS_SCHOOL_USER_DTO.REQUEST:
            return {
                ...state,
                addingStudents: true,
                studentInviteResult: null,
            }
        case organizationConstants.INVITE_STUDENTS_SCHOOL_USER_DTO.SUCCESS:
            return {
                ...state,
                studentAddedSuccess: true,
                addingStudents: false,
                studentInviteResult: action.data,
            }
        case organizationConstants.INVITE_STUDENTS_SCHOOL_USER_DTO.FAILURE:
            return {
                ...state,
                addingStudents: false,
                studentInviteResult: null,
                error: action.message,
            }

        case organizationConstants.INVITE_STUDENTS_SCHOOL_WITH_PHONE.REQUEST:
            return {
                ...state,
                addingStudents: true,
            }
        case organizationConstants.INVITE_STUDENTS_SCHOOL_WITH_PHONE.SUCCESS:
            return {
                ...state,
                studentAddedSuccess: true,
                addingStudents: false,
            }
        case organizationConstants.INVITE_STUDENTS_SCHOOL_WITH_PHONE.FAILURE:
            return {
                ...state,
                error: action.message,
            }


        case organizationConstants.GET_ORGANIZATION_USERS.REQUEST:
            return {
                ...state,
                isFetchingOrganizationUsers: true,
            }
        case organizationConstants.GET_ORGANIZATION_USERS.SUCCESS:
            return {
                ...state,
                organizationUsers: action.data,
                isFetchingOrganizationUsers: false,
            }
        case organizationConstants.GET_ORGANIZATION_USERS.FAILURE:
            return {
                ...state,
                error: action.message,
                organizationUsers: [],
                isFetchingOrganizationUsers: false,
            }

        case organizationConstants.GET_INVITE_ROLES_AVAILABLE.REQUEST:
            return {
                ...state,
            }
        case organizationConstants.GET_INVITE_ROLES_AVAILABLE.SUCCESS:
            return {
                ...state,
                inviteRolesAvailable: action.data,
            }
        case organizationConstants.GET_INVITE_ROLES_AVAILABLE.FAILURE:
            return {
                ...state,
                error: action.message,
                inviteRolesAvailable: [],
            }
        case organizationConstants.DELETE_ORGANIZATION_USER.REQUEST:
            return {
                ...state,
            }
        case organizationConstants.DELETE_ORGANIZATION_USER.SUCCESS:
            return {
                ...state,
            }
        case organizationConstants.DELETE_ORGANIZATION_USER.FAILURE:
            return {
                ...state,
                error: action.message,
            }

        case organizationConstants.GET_ORGANIZATION_ASSETS.SUCCESS:
            return {
                ...state,
                organizationFileAssets: action.data,
            }
        case organizationConstants.GET_ORGANIZATION_ASSETS.FAILURE:
            return {
                ...state,
                organizationFileAssets: [],
                error: action.message,
            }

        case organizationConstants.UPDATE_ORGANIZATION_INFO.REQUEST:
            return {
                ...state,
            }
        case organizationConstants.UPDATE_ORGANIZATION_INFO.SUCCESS:
            return {
                ...state,
            }
        case organizationConstants.UPDATE_ORGANIZATION_INFO.FAILURE:
            return {
                ...state,
            }

        case organizationConstants.GET_ORGANIZATION_ASSETS.REQUEST:
            return {
                ...state,
            }

        case organizationConstants.UPDATE_ORGANIZATION_ASSET.SUCCESS:
            return {
                ...state,
                organizationFileAssets: action.data,
            }
        case organizationConstants.UPDATE_ORGANIZATION_ASSET.FAILURE:
            return {
                ...state,
                organizationFileAssets: [],
                error: action.message,
            }
        case organizationConstants.UPDATE_ORGANIZATION_ASSET.REQUEST:
            return {
                ...state,
            }

        case organizationConstants.DELETE_ORGANIZATION_ASSET.SUCCESS:
            return {
                ...state,
                organizationFileAssets: action.data,
            }
        case organizationConstants.DELETE_ORGANIZATION_ASSET.FAILURE:
            return {
                ...state,
                organizationFileAssets: [],
                error: action.message,
            }
        case organizationConstants.DELETE_ORGANIZATION_ASSET.REQUEST:
            return {
                ...state,
            }
        case organizationConstants.EXPORT_EXCEL_FROM_TEMPLATE_ORG_STATS.REQUEST:
            return {
                ...state,
                isExportingOrgExcelReport: true,
            }
        case organizationConstants.EXPORT_EXCEL_FROM_TEMPLATE_ORG_STATS.SUCCESS:
            return {
                ...state,
                isExportingOrgExcelReport: false,
            }
        case organizationConstants.EXPORT_EXCEL_FROM_TEMPLATE_ORG_STATS.FAILURE:
            return {
                ...state,
                error: action.message,
                isExportingOrgExcelReport: false,
            }
        case organizationConstants.EXPORT_EXCEL_FROM_TEMPLATE_CLASSROOM_STATS.REQUEST:
            return {
                ...state,
            }
        case organizationConstants.EXPORT_EXCEL_FROM_TEMPLATE_CLASSROOM_STATS.SUCCESS:
            return {
                ...state,
            }
        case organizationConstants.EXPORT_EXCEL_FROM_TEMPLATE_CLASSROOM_STATS.FAILURE:
            return {
                ...state,
                error: action.message,
            }
        case organizationConstants.EXPORT_COURSE_GROUP_PROGRESSION_ORG.REQUEST:
            return {
                ...state,
                isExportingCourseGroupProgression: true,
            }
        case organizationConstants.EXPORT_COURSE_GROUP_PROGRESSION_ORG.SUCCESS:
            return {
                ...state,
                isExportingCourseGroupProgression: false,
            }
        case organizationConstants.EXPORT_COURSE_GROUP_PROGRESSION_ORG.FAILURE:
            return {
                ...state,
                error: action.message,
                isExportingCourseGroupProgression: false,
            }
        case organizationConstants.EXPORT_COURSE_GROUP_PROGRESSION_STUDENT.REQUEST:
            return {
                ...state,
                isExportingStudentProgression: true,
            }
        case organizationConstants.EXPORT_COURSE_GROUP_PROGRESSION_STUDENT.SUCCESS:
            return {
                ...state,
                isExportingStudentProgression: false,
            }
        case organizationConstants.EXPORT_COURSE_GROUP_PROGRESSION_STUDENT.FAILURE:
            return {
                ...state,
                error: action.message,
                isExportingStudentProgression: false,
            }
        case organizationConstants.EXPORT_COURSE_GROUP_PROGRESSION_CLASSROOM.REQUEST:
            return {
                ...state,
                isExportingClassroomProgression: true,
            }
        case organizationConstants.EXPORT_COURSE_GROUP_PROGRESSION_CLASSROOM.SUCCESS:
            return {
                ...state,
                isExportingClassroomProgression: false,
            }
        case organizationConstants.EXPORT_COURSE_GROUP_PROGRESSION_CLASSROOM.FAILURE:
            return {
                ...state,
                error: action.message,
                isExportingClassroomProgression: false,
            }
        case organizationConstants.GET_AVAILABLE_COURSE_GROUPS.SUCCESS:
            return {
                ...state,
                availableCourseGroups: action.data,
                fetchingCourseGroups: false,
            }
        case organizationConstants.GET_AVAILABLE_COURSE_GROUPS.FAILURE:
            return {
                ...state,
                availableCourseGroups: [],
                fetchingCourseGroups: false,
                error: action.message,
            }
        case organizationConstants.GET_AVAILABLE_COURSE_GROUPS.REQUEST:
            return {
                ...state,
                fetchingCourseGroups: true,
            }

        case organizationConstants.GET_GRAPH_DATA_HOURLY_ORG.SUCCESS:
            return {
                ...state,
                graphDataHourlyOrganization: action.data,
            }
        case organizationConstants.GET_GRAPH_DATA_HOURLY_ORG.FAILURE:
            return {
                ...state,
                graphDataHourlyOrganization: null,
                error: action.message,
            }
        case organizationConstants.GET_GRAPH_DATA_HOURLY_ORG.REQUEST:
            return {
                ...state,
            }

        case organizationConstants.GET_GRAPH_DATA_HOURLY_USER_GROUP.SUCCESS:
            return {
                ...state,
                graphDataHourlyUserGroup: action.data,
            }
        case organizationConstants.GET_GRAPH_DATA_HOURLY_USER_GROUP.FAILURE:
            return {
                ...state,
                graphDataHourlyUserGroup: null,
                error: action.message,
            }
        case organizationConstants.GET_GRAPH_DATA_HOURLY_USER_GROUP.REQUEST:
            return {
                ...state,
            }

        case organizationConstants.GET_GRAPH_DATA_DAY_OF_WEEK_ORG.SUCCESS:
            return {
                ...state,
                graphDataDayOfWeekOrganization: action.data,
            }
        case organizationConstants.GET_GRAPH_DATA_DAY_OF_WEEK_ORG.FAILURE:
            return {
                ...state,
                graphDataDayOfWeekOrganization: null,
                error: action.message,
            }
        case organizationConstants.GET_GRAPH_DATA_DAY_OF_WEEK_ORG.REQUEST:
            return {
                ...state,
            }

        case organizationConstants.GET_GRAPH_DATA_DAY_OF_WEEK_USER_GROUP.SUCCESS:
            return {
                ...state,
                graphDataDayOfWeekUserGroup: action.data,
            }
        case organizationConstants.GET_GRAPH_DATA_DAY_OF_WEEK_USER_GROUP.FAILURE:
            return {
                ...state,
                graphDataDayOfWeekUserGroup: null,
                error: action.message,
            }
        case organizationConstants.GET_GRAPH_DATA_DAY_OF_WEEK_USER_GROUP.REQUEST:
            return {
                ...state,
            }

        case organizationConstants.GET_GRAPH_DATA_DAILY_USAGE_AGGREGATED_USER_GROUP.SUCCESS:
            return {
                ...state,
                graphDataDailyUsageAggregatedUserGroup: action.data,
            }
        case organizationConstants.GET_GRAPH_DATA_DAILY_USAGE_AGGREGATED_USER_GROUP.FAILURE:
            return {
                ...state,
                graphDataDailyUsageAggregatedUserGroup: null,
                error: action.message,
            }
        case organizationConstants.GET_GRAPH_DATA_DAILY_USAGE_AGGREGATED_USER_GROUP.REQUEST:
            return {
                ...state,
            }

        case organizationConstants.GET_GRAPH_DATA_DAILY_USAGE_AGGREGATED_ORG.SUCCESS:
            return {
                ...state,
                graphDataDailyUsageAggregatedOrg: action.data,
            }
        case organizationConstants.GET_GRAPH_DATA_DAILY_USAGE_AGGREGATED_ORG.FAILURE:
            return {
                ...state,
                graphDataDailyUsageAggregatedOrg: null,
                error: action.message,
            }
        case organizationConstants.GET_GRAPH_DATA_DAILY_USAGE_AGGREGATED_ORG.REQUEST:
            return {
                ...state,
            }

        case organizationConstants.GET_GRAPH_DATA_DAILY_LESSON_AGGREGATED_USER_GROUP.SUCCESS:
            return {
                ...state,
                graphDataDailyLessonAggregatedUserGroup: action.data,
            }
        case organizationConstants.GET_GRAPH_DATA_DAILY_LESSON_AGGREGATED_USER_GROUP.FAILURE:
            return {
                ...state,
                graphDataDailyLessonAggregatedUserGroup: null,
                error: action.message,
            }
        case organizationConstants.GET_GRAPH_DATA_DAILY_LESSON_AGGREGATED_USER_GROUP.REQUEST:
            return {
                ...state,
            }

        case organizationConstants.GET_GRAPH_DATA_DAILY_LESSON_AGGREGATED_ORG.SUCCESS:
            return {
                ...state,
                graphDataDailyLessonAggregatedOrg: action.data,
            }
        case organizationConstants.GET_GRAPH_DATA_DAILY_LESSON_AGGREGATED_ORG.FAILURE:
            return {
                ...state,
                graphDataDailyLessonAggregatedOrg: null,
                error: action.message,
            }
        case organizationConstants.GET_GRAPH_DATA_DAILY_LESSON_AGGREGATED_ORG.REQUEST:
            return {
                ...state,
            }

        case organizationConstants.GET_ORGANIZATION_TIME_ZONE_LOCATIONS.REQUEST:
            return {
                ...state,
            }
        case organizationConstants.GET_ORGANIZATION_TIME_ZONE_LOCATIONS.SUCCESS:
            return {
                ...state,
                timeZoneLocations: action.data,
            }
        case organizationConstants.GET_ORGANIZATION_TIME_ZONE_LOCATIONS.FAILURE:
            return {
                ...state,
                error: action.message,
            }

        case organizationConstants.SET_ORGANIZATION_TIME_ZONE_LOCATION.REQUEST:
            return {
                ...state,
            }
        case organizationConstants.SET_ORGANIZATION_TIME_ZONE_LOCATION.SUCCESS:
            return {
                ...state,
            }
        case organizationConstants.SET_ORGANIZATION_TIME_ZONE_LOCATION.FAILURE:
            return {
                ...state,
                error: action.message,
            }

        case organizationConstants.GET_ORGANIZATION_COURSE_GROUPS.REQUEST:
            return {
                ...state,
            }
        case organizationConstants.GET_ORGANIZATION_COURSE_GROUPS.SUCCESS:
            return {
                ...state,
                organizationCourseGroups: action.data,
            }
        case organizationConstants.GET_ORGANIZATION_COURSE_GROUPS.FAILURE:
            return {
                ...state,
                error: action.message,
            }

        case organizationConstants.ADD_COURSE_GROUP_TO_ORGANIZATION.REQUEST:
            return {
                ...state,
            }
        case organizationConstants.ADD_COURSE_GROUP_TO_ORGANIZATION.SUCCESS:
            return {
                ...state,
                organizationCourseGroups: action.data,
            }
        case organizationConstants.ADD_COURSE_GROUP_TO_ORGANIZATION.FAILURE:
            return {
                ...state,
                error: action.message,
            }

        case organizationConstants.REMOVE_COURSE_GROUP_FROM_ORGANIZATION.REQUEST:
            return {
                ...state,
            }
        case organizationConstants.REMOVE_COURSE_GROUP_FROM_ORGANIZATION.SUCCESS:
            return {
                ...state,
                organizationCourseGroups: action.data,
            }
        case organizationConstants.REMOVE_COURSE_GROUP_FROM_ORGANIZATION.FAILURE:
            return {
                ...state,
                error: action.message,
            }

        case organizationConstants.GET_ORGANIZATION_FACT_BOX_STATS.REQUEST:
            return {
                ...state,
            }
        case organizationConstants.GET_ORGANIZATION_FACT_BOX_STATS.SUCCESS:
            // A new object rather than mutating the existing one. The previous version wrote into
            // the same map and handed the same reference back, so anything memoising on it never
            // saw the new figures arrive.
            return {
                ...state,
                organizationIdToFactBoxStats: {
                    ...(state.organizationIdToFactBoxStats || {}),
                    [action.data.organizationId]: action.data,
                },
            }
        case organizationConstants.GET_ORGANIZATION_FACT_BOX_STATS.FAILURE:
            return {
                ...state,
            }

        case organizationConstants.GET_ORGANIZATION_COURSE_GROUP_USAGE.REQUEST:
            return {
                ...state,
            }
        case organizationConstants.GET_ORGANIZATION_COURSE_GROUP_USAGE.SUCCESS:
            return {
                ...state,
                organizationCourseGroupUsage: action.data,
            }
        case organizationConstants.GET_ORGANIZATION_COURSE_GROUP_USAGE.FAILURE:
            return {
                ...state,
            }

        case organizationConstants.GET_COURSE_STATS_OVERVIEW.REQUEST:
            return {
                ...state,
                courseStatsOverviewLoading: true,
            }
        case organizationConstants.GET_COURSE_STATS_OVERVIEW.SUCCESS:
            return {
                ...state,
                courseStatsOverviewLoading: false,
                courseStatsOverview: action.data,
            }
        case organizationConstants.GET_COURSE_STATS_OVERVIEW.FAILURE:
            return {
                ...state,
                courseStatsOverviewLoading: false,
            }

        case organizationConstants.GET_COURSE_STATS_TOPIC_TREND.REQUEST:
            return {
                ...state,
                courseStatsTopicTrendLoading: true,
            }
        case organizationConstants.GET_COURSE_STATS_TOPIC_TREND.SUCCESS:
            return {
                ...state,
                courseStatsTopicTrendLoading: false,
                courseStatsTopicTrend: action.data,
            }
        case organizationConstants.GET_COURSE_STATS_TOPIC_TREND.FAILURE:
            return {
                ...state,
                courseStatsTopicTrendLoading: false,
            }

        case organizationConstants.GET_COURSE_STATS_FILTER_PRESETS.SUCCESS:
            return {
                ...state,
                courseStatsFilterPresets: action.data,
            }

        case organizationConstants.GET_COURSE_STATS_CATALOGUE.SUCCESS:
            return {
                ...state,
                courseStatsCatalogue: action.data,
            }

        case organizationConstants.EXPORT_COURSE_STATS_FILTER.REQUEST:
            return {
                ...state,
                courseStatsExporting: true,
            }
        case organizationConstants.EXPORT_COURSE_STATS_FILTER.SUCCESS:
        case organizationConstants.EXPORT_COURSE_STATS_FILTER.FAILURE:
            return {
                ...state,
                courseStatsExporting: false,
            }

        case organizationConstants.POST_COURSE_STATS_FILTER.REQUEST:
            return {
                ...state,
                courseStatsFilterLoading: true,
            }
        case organizationConstants.POST_COURSE_STATS_FILTER.SUCCESS:
            return {
                ...state,
                courseStatsFilterLoading: false,
                courseStatsFilterResult: action.data,
            }
        case organizationConstants.POST_COURSE_STATS_FILTER.FAILURE:
            return {
                ...state,
                courseStatsFilterLoading: false,
            }
        case organizationConstants.CLEAR_COURSE_STATS_FILTER_RESULT:
            // Also clears the in-flight flags. Entering the page is a fresh start, and a spinner
            // left over from a request that never resolved - a cancelled takeLatest, or a 401 that
            // redirected mid-flight - has nothing behind it and will never stop on its own.
            return {
                ...state,
                courseStatsFilterResult: null,
                courseStatsFilterLoading: false,
                courseStatsExporting: false,
            }

        case organizationConstants.SKILLS_COURSES_FOR_ORG.REQUEST:
            return {
                ...state,
            }
        case organizationConstants.SKILLS_COURSES_FOR_ORG.SUCCESS:
            return {
                ...state,
                skillsCourses: action.data,
            }
        case organizationConstants.SKILLS_COURSES_FOR_ORG.FAILURE:
            return {
                ...state,
                skillsCourses: [],
            }
        case organizationConstants.DOWNLOAD_USER_IMPORT_TEMPLATE.REQUEST:
            return {
                ...state,
                isDownloadingImportTemplate: true,
            }
        case organizationConstants.DOWNLOAD_USER_IMPORT_TEMPLATE.SUCCESS:
            return {
                ...state,
                isDownloadingImportTemplate: false,
            }
        case organizationConstants.DOWNLOAD_USER_IMPORT_TEMPLATE.FAILURE:
            return {
                ...state,
                isDownloadingImportTemplate: false,
                error: action.message,
            }

        case organizationConstants.UPLOAD_USER_IMPORT.REQUEST:
            return {
                ...state,
                isUploadingUserImport: true,
                userImportResult: null,
                userImportError: null,
            }
        case organizationConstants.UPLOAD_USER_IMPORT.SUCCESS:
            return {
                ...state,
                isUploadingUserImport: false,
                userImportResult: action.data,
            }
        case organizationConstants.UPLOAD_USER_IMPORT.FAILURE:
            return {
                ...state,
                isUploadingUserImport: false,
                userImportError: action.message,
            }

        case organizationConstants.RESET_USER_IMPORT:
            return {
                ...state,
                userImportResult: null,
                userImportError: null,
            }

        case organizationConstants.RESET_STUDENT_INVITE:
            return {
                ...state,
                studentInviteResult: null,
            }

        case organizationConstants.PREVIEW_ORGANIZATION_EMAIL.REQUEST:
            return {
                ...state,
                isFetchingEmailPreview: true,
            }
        case organizationConstants.PREVIEW_ORGANIZATION_EMAIL.SUCCESS:
            return {
                ...state,
                isFetchingEmailPreview: false,
                emailPreviewResult: action.data,
            }
        case organizationConstants.PREVIEW_ORGANIZATION_EMAIL.FAILURE:
            return {
                ...state,
                isFetchingEmailPreview: false,
                emailPreviewResult: null,
                error: action.message,
            }

        case organizationConstants.SEND_ORGANIZATION_EMAIL.REQUEST:
            return {
                ...state,
                isSendingOrganizationEmail: true,
                emailSendResult: null,
            }
        case organizationConstants.SEND_ORGANIZATION_EMAIL.SUCCESS:
            return {
                ...state,
                isSendingOrganizationEmail: false,
                emailSendResult: action.data,
            }
        case organizationConstants.SEND_ORGANIZATION_EMAIL.FAILURE:
            return {
                ...state,
                isSendingOrganizationEmail: false,
                emailSendResult: null,
                error: action.message,
            }

        case organizationConstants.RESET_ORGANIZATION_EMAIL:
            return {
                ...state,
                emailPreviewResult: null,
                emailSendResult: null,
                isFetchingEmailPreview: false,
                isSendingOrganizationEmail: false,
            }

        case authConstants.LOGOUT.SUCCESS:
            return initialState
        default:
            return state
    }
}
